import { storyblokEditable } from "@storyblok/react";

const HeaderBlock = ({ blok }) => {
  return (
    <div {...storyblokEditable(blok)} className="block-image">
      <div className="container herosub">
        <h1>{blok.title}</h1>
        <h2>{blok.subtitle}</h2>
      </div>
    </div>
  );
};

export default HeaderBlock;
